
import TVScreenFrame from "./TVScreenFrame";

function IntroC({ image = "assets/walkthrough/radar_sequence.mov", text, background = "/assets/walkthrough/no_screen_room.webp" }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        position: "relative",
        background: `url(${background}) center center / cover no-repeat`,
        overflow: "hidden",
      }}
    >
      <TVScreenFrame background={background}>
        <video
          src={image}
          autoPlay
          loop
          muted
          style={{
            width: "97%",
            height: "97%",
            boxShadow: "0 0 24px 0 #000 inset",
            background: "#111",
            objectFit: "cover",
            display: "block",
            borderRadius: "8px",
          }}
        />
      </TVScreenFrame>

      {/* Floating scenario box below TV */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "calc(40% + 18vw)", // below TV frame
          transform: "translate(-50%, 0)",
          background: "#fff",
          borderRadius: 10,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "80vw",
          maxWidth: "70%",
          minHeight: 100,
          padding: "32px 24px",
          zIndex: 10,
        }}
      >
        <div
          style={{
            paddingLeft: 24,
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontSize: 24, color: "#222", fontWeight: 600 }}>
            {text}
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntroC;
